<template>
  <div class="custom-input-color-group">
    <i class="custom-input-color-icon"></i>
    <input
      class="form-control"
      v-bind="$attrs"
      v-on="inputListeners"
      :value="value"
      :data-testid="testid"
    >
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: ['value', 'testid'],
    computed: {
      inputListeners: function () {
        let vm = this;
        return Object.assign({},
          this.$listeners,
          {
            input: function (event) {
              vm.$emit('update', event.target.value);
            },
            focus: function() {
              vm.$emit('focus', true);
            },
            click: function (e) {
              e.stopPropagation();
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  .custom-input-color-group {
    position: relative;
  }
  .custom-input-color-icon {
    background: url('~images/icons-rainbow-circle.png') right no-repeat;
    position: absolute;
    width: 16px;
    height: 16px;
    right: 8px;
    top: calc(50% - 16px/2);
  }

</style>